














































































































import {
  SfButton,
  SfLoader,
  SfInput,
  SfHeading,
} from '@storefront-ui/vue';
import {
  ref,
  computed,
  defineComponent,
  useContext,
  useRoute, useMeta,
} from '@nuxtjs/composition-api';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { email, required } from 'vee-validate/dist/rules';
import { forgotPasswordGetters } from '~/modules/customer/getters/forgotPasswordGetters';
import {useForgotPassword, usePage} from '~/composables';
import { customerPasswordRegExp, invalidPasswordMsg } from '~/modules/customer/helpers/passwordValidation';
import DsbInput from "~/components/Form/DsbInput.vue";
import {getInstance} from "~/helpers/hooks/getInstance";
import {PageCategory} from "~/types/PageCategory";
import {Header} from "~/types/homePage/HomepageCategories";

extend('email', {
  ...email,
  message: 'Ungültige E-Mail-Adresse',
});

extend('required', {
  ...required,
  message: 'Dieses Feld ist erforderlich',
});

extend('password', {
  message: invalidPasswordMsg,
  validate: (value: string) => customerPasswordRegExp.test(value),
});

export default defineComponent({
  name: 'ResetPassword',
  components: {
    DsbInput,
    SfButton,
    SfHeading,
    SfLoader,
    SfInput,
    ValidationProvider,
    ValidationObserver,
  },
  layout: 'login',
  // eslint-disable-next-line consistent-return
  middleware({ redirect, route }) {
    if (!route.query.token) {
      return redirect('/');
    }
  },
  setup() {
    const {
      result,
      setNew,
      error: forgotPasswordError,
      loading: forgotPasswordLoading,
    } = useForgotPassword();
    const passwordMatchError = ref<string | null>(null);

    const form = ref({
      email: '',
      password: '',
      repeatPassword: '',
    });
    const isPasswordChanged = computed(() => forgotPasswordGetters.isPasswordChanged(result.value));

    const route = useRoute();
    const { token } = route.value.query;
    // @ts-expect-error Recaptcha is not registered as a Nuxt module. Its absence is handled in the code
    const { $recaptcha, $config } = useContext();
    const isRecaptchaEnabled = ref(typeof $recaptcha !== 'undefined' && $config.isRecaptcha);

    const { pageTitle } = usePage()
    const {title} = useMeta()

    pageTitle.value = 'Neues Passwort erstellen'
    title.value = pageTitle.value

    const setNewPassword = async () => {
      passwordMatchError.value = null;
      if (form.value.password !== form.value.repeatPassword) {
        passwordMatchError.value = 'Die eingegebenen Passwörter stimmen nicht überein';
        return;
      }

      if (isRecaptchaEnabled.value) {
        $recaptcha.init();
      }

      if (isRecaptchaEnabled.value) {
        const recaptchaToken = await $recaptcha.getResponse();

        await setNew({
          tokenValue: token as string,
          newPassword: form.value.password,
          email: form.value.email,
          recaptchaToken,
        });
      } else {
        await setNew({
          tokenValue: token as string,
          newPassword: form.value.password,
          email: form.value.email,
        });
      }

      if (isRecaptchaEnabled.value) {
        $recaptcha.reset();
      }
    };

    return {
      isPasswordChanged,
      form,
      setNewPassword,
      forgotPasswordLoading,
      forgotPasswordError,
      passwordMatchError,
      token,
      result,
      isRecaptchaEnabled,
      pageTitle,
    };
  },
  //@ts-ignore
  head(){},
});
